import { useAsyncExecutor } from "async-executor-hook";
import { Toast } from "primereact/toast";
import { stringify } from "query-string";
import { useEffect, useRef } from "react";
import {
  FormControl,
  FormGroup,
  useFormConfig,
  WForm,
  WFormControl,
} from "rectangular-forms";
import { BodyContainerTableCommon } from "../../../common/components/TableResponsive";
import {
  onlyDigitsNumbers,
  WInputText,
} from "../../../common/components/TemplateContainer/InputTemplates";
import { SaveButton } from "../../../common/components/TemplateContainer/SaveButton";
import { TemplateInputContainer } from "../../../common/components/TemplateContainer/TemplateContainer";
import { getErrorValueResponse } from "../../../common/error/Error";
import { removeNullProps } from "../../../common/utils";
import { HTTP_METHODS } from "../../../utils/constants";
import { networkBackendRequest } from "../../../utils/networkUtils";
import { ContainerInputs, ContainerTitleSync } from "../SyncronizeDataStyled";

interface IcreateUserAgentRUCParams {
  ruc_number: string;
  succeed?: any;
  failed?: any;
}

export const SyncronizeAgentsByRuc = () => {
  const toast: any = useRef();
  const formConfig = useFormConfig({
    createForm: (data) => {
      const form = new FormGroup({
        ruc_number: new FormControl(),
      });
      form.patchValue(data);
      return form;
    },
    onSubmit: (form, { processing, succeed, failed }) => {
      if (form.invalid) {
        toast.current.show({
          severity: "error",
          summary:
            "Completar todos los campos obligatorios antes de continuar. ¡Gracias!",
          contentClassName: "",
        });
        return;
      }
      processing();
      createUserExecutor.execute({ ...form.value, succeed, failed });
    },
  });

  const createUserExecutor = useAsyncExecutor(
    (params: IcreateUserAgentRUCParams) => {
      const { ruc_number } = params;
      const ruc = ruc_number;
      const urlPostRuc = `/sync-engine/manual-synchronization/by-ruc/${ruc}/?${stringify(
        removeNullProps({ ruc })
      )}`;
      return networkBackendRequest(urlPostRuc, HTTP_METHODS.POST).then((resp) =>
        resp.json()
      );
    },
    {
      onSuccess: (_, params: IcreateUserAgentRUCParams) => {
        params.succeed();
        formConfig.loadSucceed({});
        toast.current.show({
          severity: "success",
          summary: "Operación exitosa",
          detail: `La sincronización de ${params.ruc_number} se realizó con éxito.`,
          life: 5000,
        });
      },
      onError(error, params: IcreateUserAgentRUCParams) {
        const errorMessage = getErrorValueResponse(error);
        params.failed();
        toast.current.show({
          severity: "error",
          summary: "Atención",
          detail: errorMessage,
          life: 3000,
        });
      },
    }
  );

  useEffect(() => {
    formConfig.loadSucceed({});
    // eslint-disable-next-line
  }, []);
  return (
    <div>
      <Toast ref={toast}></Toast>
      <WForm formConfig={formConfig} style={{ width: "100%" }}>
        <BodyContainerTableCommon className="item-container" height="10rem">
          <div
            className="attribute"
            style={{
              display: "flex",
              alignItems: "flex-start",
              height: "100%",
            }}
          >
            <div className="titles">{"Sincronizar"}</div>
            <ContainerTitleSync>
              <div style={{ fontSize: "1.6rem", color: "#2E353D" }}>
                En base al N° ruc
              </div>
              <div style={{ fontSize: "1.2rem", color: "#989CA2" }}>
                <p style={{ maxWidth: "27rem" }}>
                  Sincronice la información de las agencias en base a su{" "}
                  <strong>RUC.</strong>
                </p>
              </div>
            </ContainerTitleSync>
          </div>
          <div className="attribute" style={{ height: "100%" }}>
            <div className="titles">{"PARÁMETROS DE SINCRONIZACIÓN"}</div>
            <div className="left-align" style={{ width: "100%" }}>
              <ContainerInputs>
                <div>
                  <WFormControl name="ruc_number">
                    <TemplateInputContainer label="N° RUC" color="#002E6C">
                      <WInputText
                        width="20rem"
                        height="4rem"
                        fontSize="1.4rem"
                        placeholder="Número de ruc"
                        maxLength={11}
                        onKeyPress={onlyDigitsNumbers}
                      />
                    </TemplateInputContainer>
                  </WFormControl>
                </div>
                <div></div>
              </ContainerInputs>
            </div>
          </div>
          <div className="attribute" style={{ height: "100%" }}>
            <div className="titles">{"ACCIONES"}</div>
            <div className="left-align">
              <SaveButton
                label="Sincronizar"
                width="17rem"
                height="3.8rem"
                fontSize="1.5rem"
                backgroundColor="#002E6C"
                isDisabled={formConfig?.form?.value?.ruc_number?.length !== 11}
              />
            </div>
          </div>
        </BodyContainerTableCommon>
      </WForm>
    </div>
  );
};
